<template>
  <div>
    <el-button type="text" style="margin-left: 16px;color: #606266" @click="drawer = true"><i class="el-icon-edit-outline" />&nbsp;{{ showAbility() }}</el-button>
    <el-drawer
      title="能力配置"
      :visible.sync="drawer"
      direction="rtl"
      size="500"
    >
      <el-table :data="value" border stripe>
        <el-table-column prop="id" label="id" width="200px">
          <template v-slot:default="scope">
            <el-select v-model="scope.row.id" placeholder="请选择" @change="listenType">
              <el-option
                v-for="item in abilityArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="v" label="概率(%)" width="100">
          <template v-slot:default="scope">
            <el-input v-model="scope.row.v" placeholder="概率" />
          </template>
        </el-table-column>
        <el-table-column prop="num" label="数量(%)" width="100">
          <template v-slot:default="scope">
            <el-input v-model="scope.row.num" placeholder="数量" />
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot:default="scope">
            <el-button type="danger" size="mini" @click="del(scope.$index, scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button style="margin-top: 10px;" type="primary" size="mini" @click="add">+</el-button>
    </el-drawer>

  </div>
</template>

<script>
import { getAbilityConfig } from '@/api/config/area-cfg'
import { getCacheConfig } from '@/utils'
export default {
  name: 'Ability',
  props: {
    value: {
      type: Array,
      default: () => ([]),
      required: false
    }
  },
  data() {
    return {
      selseted: [],
      drawer: false,
      abilityArr: []
    }
  },
  watch: {
    drawer: function(val) {
      if (val) {
        this.listenType(1)
      }
    },
    value: function(newVal) {
      this.$emit('input', newVal)
    }
  },
  created() {
    this.getAbility()
  },
  methods: {
    getAbility() {
      getCacheConfig(getAbilityConfig, 'getAbilityConfig').then(res => {
        this.abilityArr = []
        this.selseted = []
        for (const i in res.data) {
          this.abilityArr.push({ label: res.data[i], value: parseInt(i), disabled: false })
        }
      })
    },
    add() {
      this.listenType()
      let id = 0
      for (const i in this.abilityArr) {
        const val = this.abilityArr[i]
        if (val.disabled) {
          continue
        }
        id = val.value
        break
      }

      if (!id) {
        this.msgError('无可选类型')
        return
      }
      this.value.push({ id: id, v: 0, num: 0 })
      this.selseted.push(id)
      this.listenType()
    },
    del(idx, id) {
      this.selseted = this.selseted.filter(item => {
        return id !== item
      })
      this.value.splice(idx, 1)
      this.listenType()
    },
    listenType(v = null) {
      if (v) {
        this.selseted = []
        for (const i in this.value) {
          const val = this.value[i]
          this.selseted.push(val.id)
        }
      }
      for (const i in this.abilityArr) {
        const val = this.abilityArr[i]
        this.abilityArr[i].disabled = false
        if (this.selseted.includes(val.value)) {
          this.abilityArr[i].disabled = true
        }
      }
    },
    showAbility() {
      const str = []
      for (const i in this.value) {
        const val = this.value[i]
        for (const i in this.abilityArr) {
          if (val.id === this.abilityArr[i].value) {
            str.push(this.abilityArr[i].label + '-' + val.num + '-' + val.v)
          }
        }
      }
      if (str.length <= 0) {
        return '未配置'
      }
      return str.join(',')
    }
  }
}
</script>

<style scoped>

</style>
